import React from 'react'
import { render } from 'react-dom'
import {
    createStore,
    applyMiddleware,
    compose
} from 'redux'
import eymio from './reducers/index'
import {
    Provider
} from 'react-redux'
import {
    BrowserRouter as Router,
} from 'react-router-dom'
import thunkMiddleware from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import initialState from './reducers/store'
import Root from './root'

// Remove below in production
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
//const composeEnhancers = compose

let store = createStore(
    eymio,
    initialState,
    composeEnhancers(
        applyMiddleware(
            thunkMiddleware,
            promiseMiddleware()
        )
    )
)

render(
    <Provider store={store}>
        <Router>
            <Root />
        </Router>
    </Provider>,
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js